export default __webpack_public_path__ + "static/media/admin-panel.6e396f06.png";